import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Item, ItemLabel, ItemValue } from '../_styles'
import { useProduct } from '../../../_methods'
import DefaultTooltip from 'components/Common/Tooltips/DefaultTooltip'
import { formatIngredient } from 'utils/format'

const Ingredient = styled.span`
  &:not(:last-child)::after {
    content: ', ';
    color: #292b46;
  }

  ${props => props.isAllergen && 'color: #CC7400;'}
`

const Ingredients = () => {
  const { t } = useTranslation()

  const product = useProduct()
  const ingredients = product?.wine?.ingredients ?? []

  if (ingredients.length === 0) return null

  return (
    <Item>
      <ItemLabel>{t('wine.view.ingredients')}</ItemLabel>
      <ItemValue>
        {ingredients.map(ingredient =>
          ingredient.isAllergen ? (
            <DefaultTooltip
              key={ingredient.id}
              component={Ingredient}
              placement='top'
              tooltip={t('wine.view.ingredientsAllergen')}
              isAllergen={true}
            >
              {formatIngredient(ingredient)}
            </DefaultTooltip>
          ) : (
            <Ingredient key={ingredient.id}>
              {formatIngredient(ingredient)}
            </Ingredient>
          )
        )}
      </ItemValue>
    </Item>
  )
}

export default Ingredients
